<template>
  <div class="column is-12 is-paddingless">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('catalogue.newProduct.editionDcf.title') }}
        </p>
      </header>
      <div class="card-content columns">
        <parametre-autocomplete
          :label="$t('catalogue.newProduct.editionDcf.categorieGroupeProduitDeductible')"
          v-model="produit.categorieGroupeProduitDeductibleId"
          :target="constantes.PARAMETRES_KEYS.categorieGroupeProduitDeductible"
          expanded
          class="column is-7"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  components: {
    parametreAutocomplete,
  },
  data() {
    return {
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
};
</script>
